import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import ActionSection from '../../components/ActionSection';
import NevoBanner from '../../components/NevoBanner';

import styles from './styles.module.scss'
import EnergyManagmentBackground from '../../public/assets/images/energy-managment-header.jpg';
import EnergyManagmentImage from '../../public/assets/images/energy-managment-background.jpg'
import Link from 'next/link';
import links from '../../helper/links';
import eventGTM from '../../lib/gtag';


export default function EnergyManagmentPage()  {
  return (
    <>
      <Head>
        <title>Energy Management | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={EnergyManagmentBackground.src} className={styles.homeChargingHeader}>
        <h1 className='page-header-h1'>Energy Management.</h1>
      </PageHeader>

      <div className={`${styles.homeChargingPage} page-holder`}>
        <TextSection 
          header="There are lots of ways to power your electric vehicles and chargers."
          text={<>
            Nevo can help match your energy needs with the correct specialist from solar PV installation, to battery storage and battery buffer systems.
            <br/><br/>
            Solar energy has rapidly advanced over the past number of years. Solar is widely available and can be a truly massive benefit to any business by reducing your dependency on national energy grids, especially at peak times.
            <br/><br/>
            Another new popular use case is now the capabilities to store solar power to use to on day to day running of your building, or even as a supplement to <Link href={links.charging_solutions}><a className='link' onClick={() => eventGTM('clickedOnElectricVehicleChargingLinkOnEnergyPage')}>electric vehicle charging</a></Link>.
            <br/><br/>
            With the uncertainty in the electricity market as well as ever-changing tariffs and rates, enjoy peace of mind as you take control and manage your own energy needs.
          </>}
        />

        <div className="image-section section" style={{ backgroundImage: `url(${EnergyManagmentImage.src})` }}>&nbsp;</div>

        <ActionSection 
          header="Arrange an initial call"
          text="Looking to manage your carbon footprint? Contact us today to discover how we can help you implement energy management solutions and reduce your impact on the environment."
          buttonText="Contact Us"
          href="/contact-us"
        />

        <NevoBanner />
      </div>

      <Footer />
    </>
  )
};
